import React from "react";
import DPHeadCellWithTooltip from "Components/DP/DPHeadCell/DPHeadCell";
import { Typography } from "@material-ui/core";

const UserAdvancedHeadCell = () => {
  return <DPHeadCellWithTooltip
    label="User Advanced"
    content={
      <Typography variant="body1">
        Amount transferred plus fees
      </Typography>
    }
  />;
};

export default UserAdvancedHeadCell;
